import { BusinessAssociateBase } from './base/business-associate-base';

export class BusinessAssociate extends BusinessAssociateBase { }